import styled from "styled-components";

interface IBackIcon {
    onClick?: any;
}
const IconContainer = styled.span`
    display: flex;
    align-items: center;
    cursor: pointer;
`;

const BackIcon: React.FC<IBackIcon> = ({onClick}) => {
    return (
        <IconContainer onClick={onClick}>
            <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 1L1 7L7 13" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </IconContainer>
    )
}

export default BackIcon;